// services/apiContracts.js
// Req 1 (2026-05-13): CRUD de contratos emisor↔tercero.
import api from "./axiosConfig";

// Listar contratos. Filtros opcionales: { empresa_id, tercero_id, estado }
export const getContracts = async (filters = {}) => {
  try {
    const params = {};
    if (filters.empresa_id != null) params.empresa_id = filters.empresa_id;
    if (filters.tercero_id != null) params.tercero_id = filters.tercero_id;
    if (filters.estado) params.estado = filters.estado;
    const response = await api.get("/api/contracts/", { params });
    return response.data;
  } catch (error) {
    console.error("Error al obtener contratos:", error);
    throw error;
  }
};

// Detalle de un contrato (sin binario)
export const showContract = async (id) => {
  try {
    const response = await api.get(`/api/contracts/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error al consultar contrato:", error);
    throw error;
  }
};

// Crear contrato. Acepta body con archivo en base64.
// body = { empresa_id, tercero_id, contrato (base64), contrato_filename,
//          contrato_content_type, observaciones }
export const createContract = async (body) => {
  try {
    const response = await api.post("/api/contracts/", body);
    return response.data;
  } catch (error) {
    console.error("Error al crear contrato:", error);
    throw error;
  }
};

// Crear contrato vía multipart (alternativa, sube el File directamente sin pasar a base64).
// fileInput: instancia de File (input type=file)
export const createContractMultipart = async ({ empresa_id, tercero_id, file, observaciones, comision_servicio }) => {
  try {
    const formData = new FormData();
    formData.append("empresa_id", empresa_id);
    formData.append("tercero_id", tercero_id);
    formData.append("contrato", file);
    if (observaciones) formData.append("observaciones", observaciones);
    if (comision_servicio != null && comision_servicio !== "") {
      formData.append("comision_servicio", String(comision_servicio));
    }
    const response = await api.post("/api/contracts/", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return response.data;
  } catch (error) {
    console.error("Error al crear contrato (multipart):", error);
    throw error;
  }
};

// Editar metadata de un contrato (observaciones).
export const editContract = async (id, body) => {
  try {
    const response = await api.put(`/api/contracts/${id}`, body);
    return response.data;
  } catch (error) {
    console.error("Error al editar contrato:", error);
    throw error;
  }
};

// Cambiar estado: 'Pendiente' | 'Aprobado' | 'Rechazado'.
// Req 1 v2 (2026-05-13): acepta comision_servicio. Si se aprueba, se replica
// al tercero (clientes.comision_servicio).
export const changeContractStatus = async (id, estado, observaciones, comision_servicio) => {
  try {
    const body = { estado };
    if (observaciones != null) body.observaciones = observaciones;
    if (comision_servicio != null && comision_servicio !== "") {
      body.comision_servicio = comision_servicio;
    }
    const response = await api.put(`/api/contracts/${id}/estado`, body);
    return response.data;
  } catch (error) {
    console.error("Error al cambiar estado del contrato:", error);
    throw error;
  }
};

// Obtener blob preview-able del contrato (PDF/imagen). NO dispara descarga.
// Devuelve { url, contentType, filename } — el `url` es un object URL que
// hay que liberar con URL.revokeObjectURL cuando ya no se use.
export const previewContract = async (id) => {
  try {
    const response = await api.get(`/api/contracts/${id}/download`, {
      responseType: "arraybuffer",
    });
    const cd = response.headers["content-disposition"] || "";
    const match = cd.match(/filename="?([^"]+)"?/i);
    const filename = match ? match[1] : `contrato_${id}`;
    const contentType = response.headers["content-type"] || "application/octet-stream";
    const blob = new Blob([response.data], { type: contentType });
    const url = window.URL.createObjectURL(blob);
    return { url, contentType, filename };
  } catch (error) {
    console.error("Error al previsualizar contrato:", error);
    throw error;
  }
};

// Eliminar contrato. Param force=true bypassa la validación de
// "único Aprobado de tercero activo" (admin only).
export const deleteContract = async (id, force = false) => {
  try {
    const params = {};
    if (force) params.force = true;
    const response = await api.delete(`/api/contracts/${id}`, { params });
    return response.data;
  } catch (error) {
    console.error("Error al eliminar contrato:", error);
    throw error;
  }
};

// Descargar binario del contrato (arraybuffer → blob).
// Devuelve un objeto con { blob, filename, contentType }.
export const downloadContract = async (id) => {
  try {
    const response = await api.get(`/api/contracts/${id}/download`, {
      responseType: "arraybuffer",
    });
    // Filename viene en Content-Disposition: attachment; filename="..."
    const cd = response.headers["content-disposition"] || "";
    const match = cd.match(/filename="?([^"]+)"?/i);
    const filename = match ? match[1] : `contrato_${id}`;
    const contentType = response.headers["content-type"] || "application/octet-stream";
    const blob = new Blob([response.data], { type: contentType });
    return { blob, filename, contentType };
  } catch (error) {
    console.error("Error al descargar contrato:", error);
    throw error;
  }
};

// Helper: descargar y disparar el "Save As" del browser.
export const triggerDownloadContract = async (id) => {
  const { blob, filename } = await downloadContract(id);
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};
